module.exports = __webpack_public_path__ + "img/ic-more.2c958ef0.svg";